import { useState } from 'react';

import { useQuery } from '@apollo/client';
import {
  GetProductsByIdBatchedQuery,
  WatchdogRegisteredQuery,
  WatchdogRegisteredQueryVariables,
} from 'packages/shared/definitions/types';

import { useUser } from '@queries/useUser';

import watchdogRegisteredQuery from '../../queries/watchdogRegistered.graphql';

type UseRegisteredWatchdogParams = {
  products: GetProductsByIdBatchedQuery['vpProductByIds'];
  cacheOnly?: boolean;
};

type CatalogId = number;
type Email = string;

export const useRegisteredWatchdog = ({
  products,
}: UseRegisteredWatchdogParams) => {
  const [registeredEmails, setRegisteredEmails] = useState<
    Record<CatalogId, Email[]>
  >({});

  const { isLoggedIn } = useUser();
  const catalogIdsWithWatchdog = products
    .filter((product) => product.showWatchdog)
    .map((product) => product.catalogId);

  const alreadyFetchedIds = Object.keys(registeredEmails).map(Number);
  const catalogIdsToFetch = catalogIdsWithWatchdog.filter(
    (id) => !alreadyFetchedIds.includes(id)
  );

  const shouldSkipRequest = !isLoggedIn || catalogIdsToFetch.length === 0;

  useQuery<WatchdogRegisteredQuery, WatchdogRegisteredQueryVariables>(
    watchdogRegisteredQuery,
    {
      variables: { catalogIds: catalogIdsToFetch },
      skip: shouldSkipRequest,
      ssr: false,
      onCompleted: (data) => {
        setRegisteredEmails((prev) => ({
          ...prev,
          ...data?.watchdogRegistered?.registeredEmails,
        }));
      },
    }
  );

  return {
    registeredEmails,
  };
};
